<template>
    <div>


        <v-card>
            <iframe style=""  name="simuladoresphet" height="800" width="100%"  frameborder="0" src="https://videotecaedd.s3.amazonaws.com/Simuladores/version-para-moviles/index.html"></iframe>
        </v-card>


        
    </div>
</template>
<script>
export default {

    components:{  },

    data: () => ({}),

    mounted() {

    },

    computed: {     
     // window.open(to.meta.redirect, "_blank");
    


    },


   //metodos
    methods: {
           getContents() {
            let url = "https://phet.colorado.edu/es_PE/"
            window.open(url, "_blank")
        }


    }

  }
</script>



<style scoped>


</style>